module.exports = __webpack_public_path__ + "img/eag_logo.05bf36dc.png";